module.exports = __webpack_public_path__ + "static/b7-5de2edbe055ad82f00be01824d40b4bc.jpg";